import Login from './login/fr_FR';
import Commun from './commun/fr_FR';
import Home from './home/fr_FR';
import Administration from './administration/fr_FR';
import Recherche from './recherche/fr_FR';
import Creation from './creation/fr_FR';
import PersonneMorale from './personnemorale/fr_FR';
import PersonnePhysique from './personnephysique/fr_FR';
import Instance from './instance/fr_FR';
import Workflow from './workflow/fr_FR';
import ModificationMasse from './modificationmasse/fr_FR';

const basic = {
  locale: {
    fr_FR: 'FR',
    en_EN: 'EN',
  },
  breadcrumb: {
    youAreHere: 'Vous êtes dans :',
    goBack: 'Revenir',
  },
  menu: {
    accueil: 'Accueil',
    recherche: {
      rechercheSimple: 'Recherche simple',
      rechercheAvancee: 'Recherche avancée',
      mesRecherchesAvancees: 'Mes recherches avancées',
    },
    workflow: {
      mesDemandes: {
        title: 'Mes demandes',
      },
      demande: {
        creation: {
          title: 'Demande de création',
          titlePersonnePhysique: 'Personne physique',
          titlePersonneMorale: 'Personne morale',
          titleInstance: 'Instance',
          personnePhysique: 'Demande de création de personne physique',
          personneMorale: 'Demande de création de personne morale',
          instance: 'Demande de création d\'instance',
        },
        validation: {
          title: 'Demandes',
          personnePhysique: 'Personne physique',
          personneMorale: 'Personne morale',
          instance: 'Instance',
        },
      },
    },
    signin: 'Authentification',
    subscribe: 'Inscription',
    signout: 'Déconnexion',
    reduire: 'Réduire l\'affichage',
    monCompte: 'Gestion de mon compte',
    instances: 'Mes instances',
    mesDemandes: 'Mes demandes',
    parametres: 'Paramètres',
  },

  auth: {
    error: 'Erreur de communication avec le serveur d\'autorisation',
    unauthorized: 'Utilisateur ou mot de passe invalide',
    connected: 'Vous êtes maintenant connecté',
    disconnected: 'Vous êtes maintenant déconnecté',
    notLogged: 'Veuillez vous connecter pour accéder à cette fonction',
    accessDenied:
      'Vos habilitations ne permettent pas d\'accéder à cette fonction',
    renouvellementNonTrouve:
      'Identifiant de demande invalide ou expiré. Veuillez recommencer la procédure de réinitilisation de mot de passe',
    motDePasseChange:
      'Votre mot de passe a bien été enregistré dans l\'annuaire de l\'interprofession Laitiere. Il sera actif dans 5 min.',
    demandeReinit:
      'Un mail contenant un lien permettant la réinitilisation du mot de passe a été envoyé à votre adresse mail',
  },
  errors: {
    sirenOuSiret: 'SIREN ou SIRET non valide',
    siren: 'SIREN non valide',
    siret: 'SIRET non valide',
    required: 'Élément obligatoire',
    minLength: 'Longueur minimale de {0} charactères',
    maxLength: 'Longueur maximale de {0} charactères',
    integer: 'Champ de type entier',
    decimal: 'Champ de type décimal',
    minValue: 'Valeur minimale de {0}',
    minDate: 'La date doit être après le {0}',
    minDateOrEqual: 'La date doit être postérieure ou égale au {0}',
    maxDateOrEqual: 'La date doit être antérieure ou égale au {0}',
    startLessThanEnd:
      'La date de début doit être inférieure à la date de fin : {0}',
    maxHeure: 'L\'heure doit être avant {0}',
    minHeure: 'L\'heure doit être après {0}',
    provenanceValidator: 'La provenance du participant n\'est pas pas correcte',
    checkStringParsable: 'Le format de l\'année n\'est pas pas correct',
    email: 'Champ de type email',
    notFound: 'Objet non trouvé',
  },
  form: {
    error: 'Veuillez corriger votre saisie',
    saved: 'L\'entité a été sauvegardée',
    asked: 'La demande de modification a été transmise',
    askedcreate: 'La demande de création a été transmise',
    askedDelete: 'La demande de suppression a été transmise',
    deleted: 'L\'entité a été supprimée',
    reloaded: 'L\'entité a été rechargée',
    updatedBy: 'L\'entité a été modifiée par l\'utilisateur #%{principal}',
    deleteAll:
      '|Voulez-vous supprimer cette entité ?|Voulez-vous supprimer ces #%{count} entités ?',
    deactivateAll:
      '|Voulez-vous désactiver cette entité ?|Voulez-vous désactiver ces #%{count} entités ?',
  },
  button: {
    ok: 'OK',
    close: 'Fermer',
    cancel: 'Annuler',
    submit: 'Soumettre',
    confirm: 'Valider',
    create: 'Créer',
    new: 'Nouveau',
    quit: 'Quitter',
    send: 'Envoyer',
    deactivate: 'Désactiver',
    reload: 'Recharger',
    save: 'Enregistrer',
    modify: 'Modifier',
    delete: 'Supprimer',
    print: 'Imprimer',
    display: 'Afficher',
    export: 'Exporter',
    yes: 'Oui',
    no: 'Non',
  },
  boolean: {
    true: 'Oui',
    false: 'Non',
  },
  modal: {
    delete: 'Suppression',
    deactivate: 'Désactivation',
  },
  dataIterator: {
    rowsPerPageText: 'Élements par page :',
    rowsPerPageAll: 'Tous',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Aucun enregistrement correspondant trouvé',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente',
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page :',
  },
  noDataText: 'Aucune donnée disponible',
};

const lang = Object.assign(
  basic,
  Login,
  Commun,
  Home,
  Administration,
  Recherche,
  Creation,
  PersonneMorale,
  PersonnePhysique,
  Instance,
  Workflow,
  ModificationMasse,
);
export default lang;
